import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function scrollToLater(top, callback) {
  setTimeout(() => {
    window.scrollTo({ top, behavior: 'smooth' });
    callback?.();
  }, 0);
}

export function ScrollToTopOnNavigate() {
  const { pathname } = useLocation();

  useEffect(() => {
    setTimeout(() => window.scrollTo(0, 0), 1);
  }, [pathname]);

  return null;
}

export function ScrollTo({ selector, delay = 0, onComplete = null }) {
  useEffect(() => {
    setTimeout(() => {
      document.querySelector(selector)?.scrollIntoView?.();
      onComplete?.();
    }, delay);
  }, [selector, delay, onComplete]);

  return null;
}

export function RestoreScrollPosition({ valueKey }) {
  useEffect(() => {
    if (window[valueKey]) {
      scrollToLater(window[valueKey], () => {
        window[valueKey] = undefined;
      });
    }
  }, [valueKey]);
}
